import { format, formatDistanceToNowStrict, parseISO } from 'date-fns';
import { enUS, ru, uz, uzCyrl } from 'date-fns/locale';

const localeMap = {
  'uz-Latn': uz,
  'uz-Cyrl': uzCyrl,
  ru,
  en: enUS,
} as const;

export type LocaleKey = keyof typeof localeMap;

export function formatRelative(iso: string, lang: LocaleKey = 'uz-Latn'): string {
  return formatDistanceToNowStrict(parseISO(iso), {
    addSuffix: true,
    locale: localeMap[lang] ?? enUS,
  });
}

export function formatDateTime(iso: string, lang: LocaleKey = 'uz-Latn'): string {
  return format(parseISO(iso), 'PPp', { locale: localeMap[lang] ?? enUS });
}

export function formatTime(iso: string, lang: LocaleKey = 'uz-Latn'): string {
  return format(parseISO(iso), 'HH:mm', { locale: localeMap[lang] ?? enUS });
}

export function todayISO(): string {
  return format(new Date(), 'yyyy-MM-dd');
}
